module.exports = __webpack_public_path__ + "static/media/Character1_Shorts.5986bfbb.svg";